(function () {
  'use strict';

  var config = window.zonkeyAnalyticsConfig || {};
  var queuedEvents = [];
  var scriptRequested = false;
  var interactionSeen = false;

  function utmProperties() {
    var params = new URLSearchParams(window.location.search);
    var current = {};
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (key) {
      var value = params.get(key);
      if (value) current[key] = value;
    });

    if (Object.keys(current).length) {
      try {
        sessionStorage.setItem('zonkey_utm', JSON.stringify(current));
      } catch (error) {
        // Analytics must never interfere with storefront behavior.
      }
      return current;
    }

    try {
      return JSON.parse(sessionStorage.getItem('zonkey_utm') || '{}');
    } catch (error) {
      return {};
    }
  }

  function sendToProviders(name, properties) {
    var payload = Object.assign(
      {
        page_type: config.pageType || '',
        page_path: window.location.pathname
      },
      utmProperties(),
      properties || {}
    );

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, payload));

    if (window.rybbit && typeof window.rybbit.trackEvent === 'function') {
      window.rybbit.trackEvent(name, payload);
    } else {
      queuedEvents.push([name, payload]);
    }
  }

  window.trackZonkeyEvent = sendToProviders;

  function flushQueue() {
    if (!window.rybbit || typeof window.rybbit.trackEvent !== 'function') return;
    while (queuedEvents.length) {
      var event = queuedEvents.shift();
      window.rybbit.trackEvent(event[0], event[1]);
    }
  }

  function analyticsAllowed() {
    var customerPrivacy = window.Shopify && window.Shopify.customerPrivacy;
    return Boolean(
      customerPrivacy &&
        typeof customerPrivacy.analyticsProcessingAllowed === 'function' &&
        customerPrivacy.analyticsProcessingAllowed()
    );
  }

  function loadRybbit() {
    if (scriptRequested || !analyticsAllowed() || !config.rybbitSrc || !config.rybbitSiteId) return;
    scriptRequested = true;
    var script = document.createElement('script');
    script.src = config.rybbitSrc;
    script.dataset.siteId = config.rybbitSiteId;
    script.async = true;
    script.addEventListener('load', flushQueue, { once: true });
    document.head.appendChild(script);
  }

  function scheduleAnalytics() {
    if (interactionSeen) {
      loadRybbit();
      return;
    }
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(loadRybbit, { timeout: 3500 });
    } else {
      window.setTimeout(loadRybbit, 1500);
    }
  }

  ['pointerdown', 'keydown', 'touchstart'].forEach(function (eventName) {
    window.addEventListener(
      eventName,
      function () {
        interactionSeen = true;
        loadRybbit();
      },
      { once: true, passive: true }
    );
  });

  document.addEventListener('visitorConsentCollected', scheduleAnalytics);
  window.addEventListener('load', scheduleAnalytics, { once: true });

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href]');
    if (!link) return;
    var href = link.getAttribute('href') || '';
    if (href.indexOf('tel:') === 0) {
      sendToProviders('phone_click', { destination: href.replace('tel:', '') });
    } else if (href.indexOf('mailto:') === 0) {
      sendToProviders('email_click', { destination: href.replace('mailto:', '').split('?')[0] });
    } else if (/\/pages\/contact/.test(href)) {
      sendToProviders('appointment_intent', { link_text: (link.textContent || '').trim().slice(0, 80) });
    } else if (/^https?:/.test(href) && link.hostname !== window.location.hostname) {
      sendToProviders('outbound_click', { destination: href });
    }
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (form.matches('form[action*="/contact"]')) {
      sendToProviders('contact_form_submit', { form_id: form.id || 'contact' });
    } else if (form.matches('form[action*="/cart/add"]')) {
      sendToProviders('add_to_cart', {
        product_handle: config.productHandle,
        product_id: config.productId,
        value: config.productPrice,
        currency: 'EUR'
      });
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    if (config.pageType === 'product') {
      sendToProviders('view_item', {
        product_handle: config.productHandle,
        product_id: config.productId,
        value: config.productPrice,
        currency: 'EUR'
      });
    }

    if (document.querySelector('[data-contact-success="true"]')) {
      sendToProviders('contact_form_success', { form_id: 'ContactForm' });
    }

    var checkoutButton = document.querySelector('[name="checkout"]');
    if (checkoutButton) {
      checkoutButton.addEventListener('click', function () {
        sendToProviders('begin_checkout', { currency: 'EUR' });
      });
    }
  });
})();
